import styled from 'styled-components';

import { Container, Grid } from "@mui/material";
import CustomLink from '../CustomLink/CustomLink';

export const StyledContainer = styled(Container)`
  padding-top: 4rem;
  padding-bottom: 2rem;
  background: ${({ theme }) => theme.COLORS.BACKGROUND_BLUE};

  text-align: left;


  .politica {
    font-size: 1.4rem;
  }


  .whats-float {
position: fixed;
bottom: 2rem;
right: 2rem;
cursor: pointer;
transition: scale .3s;

&:hover {
  scale: 1.1;
}
  }
 
  @media (max-width: 900px) {
   text-align: center;
  }


  @media (max-width: 600px) {
    .whats-float {

      width: 6rem;
  }
  }



`;

export const StyledGrid = styled(Grid)`

.logo {
    padding-left: 6rem;
    text-align: left;
    img {
        width: clamp(24rem, 22vw, 46rem);
        margin-top: 2.4rem;
    }
}

.contatos {
  a {
    span {
    display: flex;
    align-items: center;
    gap: .6rem;
    }
  }
}

li {
  margin-bottom: .8rem;
}


 h1 {
    color: ${({ theme }) => theme.COLORS.YELLOW};
    font-family: 'Mont-Bold'; 
    font-size:  clamp(1.6rem, 2vw, 1.8rem);
    margin-bottom: .8rem;
    margin-top: 2.4rem;
}

p, span, a {
    color: ${({ theme }) => theme.COLORS.WHITE};
    font-family: 'Mont-Medium';
    font-size:  clamp(1.4rem, 1vw, 1.6rem);
}

p {
  line-height: 2rem;
}

 span:hover, a:hover {
    color: ${({ theme }) => theme.COLORS.YELLOW}; 
}


.top {
  margin-top: 2.4rem;
}

li {
  .link {
  color: ${({ theme }) => theme.COLORS.YELLOW}; 
}

.link:hover {
  color: ${({ theme }) => theme.COLORS.WHITE};
}
}


@media (max-width: 1200px) {
.logo {
    padding: 0;
}
}


@media (max-width: 900px) {
  padding-right: 0;

  .contatos {
  a {
    span {
    align-items: center;
    justify-content: center;
    }
  }
}

.logo {
    padding: 0;
    text-align: center;
}


h1 {
    margin-top: 4rem;
}
  }
 
`;


export const StyledLink = styled(CustomLink)`
 text-decoration: none !important;
`;

export const OutsideLink = styled.a`
 text-decoration: none !important;
`;


export const Line = styled.div`
border-top: 1px solid ${({ theme }) => theme.COLORS.WHITE};
margin-left: auto;
margin-right: auto;

margin-top: 4rem;
margin-bottom: 2rem;

width: 65%;

@media (max-width: 600px) {
    width: 100%;
  }
`;


export const Bottom = styled.div`
text-align: center;
`;




